// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    CANNEDCOMMAND_CREATE_REQUEST,
    CANNEDCOMMAND_UPDATE_REQUEST,
    CANNEDCOMMAND_GET_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    cannedCommandCreateResult,
    cannedCommandGetResult,
    cannedCommandUpdateResult,
} from 'Redux/actions';

// Helpers
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* createCannedCommand({ payload }) {
    try {

        let QUERY = `
        mutation createCannedCommand ($unitTypeId: Int, $via: enumVia!, $label: String!, $command: String!, $manufacturerId: Int!) {
            result: createCannedCommand (unitTypeId: $unitTypeId, via: $via, label: $label, command: $command, manufacturerId: $manufacturerId) {
                id
                unitTypeId
            }
        }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(cannedCommandCreateResult(data?.result))

    } catch (exc) {
        yield put(cannedCommandCreateResult())
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/cannedCommandsTab/.components/createEditCannedCommand/redux/saga",
            "createCannedCommand"
        )
    }
}

function* updateCannedCommand({ payload }) {
    try {

        let QUERY = `
        mutation updateCannedCommand ($id: Int!, $unitTypeId: Int, $via: enumVia, $label: String, $command: String, $status: enumActivationStatus) {
            result: updateCannedCommand (id: $id, unitTypeId: $unitTypeId, via: $via, label: $label, command: $command, status: $status) {
                id
            }
        }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(cannedCommandUpdateResult(data?.result))

    } catch (exc) {
        yield put(cannedCommandUpdateResult())
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/cannedCommandsTab/.components/createEditCannedCommand/redux/saga",
            "updateCannedCommand"
        )
    }
}

function* getCannedCommand({ payload }) {
    try {
        let QUERY = `
        query getCannedCommand ($id: Int!) {
           result: getCannedCommand (id: $id) {
                id
                unitTypeId
                unitType {
                    id
                    name
                    manufacturer {
                        id
                        name
                    }
                    active
                }
                via
                label
                command
                status
                appliesToAllUnitTypes
            }
        }
        `;


        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );
        
       yield put(cannedCommandGetResult(data?.result));

    } catch (exc) {
        yield put(cannedCommandGetResult());
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/cannedCommandsTab/.components/createEditCannedCommand/redux/saga",
            "getCannedCommand"
        )
    }
}

function* watchMethods() {
    yield takeEvery(CANNEDCOMMAND_CREATE_REQUEST, createCannedCommand);
    yield takeEvery(CANNEDCOMMAND_UPDATE_REQUEST, updateCannedCommand);
    yield takeEvery(CANNEDCOMMAND_GET_REQUEST, getCannedCommand);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}